import React from 'react';

/**
 * Burbuja mock de WhatsApp para previews de mensaje. Los colores de la burbuja
 * son FIJOS (verde WhatsApp claro) en ambos modos, por eso el texto va en
 * gris fijo y NO en tokens: text-content en dark sería blanco sobre verde claro.
 */
interface WhatsAppPreviewBubbleProps {
  message: string;
  images?: string[];
  /** Notas bajo la burbuja (además del "Así se verá en WhatsApp") */
  footnote?: React.ReactNode;
}

const WhatsAppPreviewBubble: React.FC<WhatsAppPreviewBubbleProps> = ({
  message,
  images = [],
  footnote,
}) => (
  <div className="max-w-sm mx-auto">
    {images.length > 0 && (
      <div className="bg-[#e7fed6] rounded-lg rounded-tr-none border border-[#d1f4c0] overflow-hidden shadow-sm mb-0">
        <img src={images[0]} alt="Preview imagen" className="w-full h-36 object-cover" />
      </div>
    )}
    <div
      className={`bg-[#e7fed6] px-3 py-2 shadow-sm border border-[#d1f4c0] ${
        images.length > 0 ? 'rounded-b-lg rounded-bl-lg border-t-0' : 'rounded-lg rounded-tr-none'
      }`}
    >
      <p className="text-sm text-gray-900 whitespace-pre-wrap leading-relaxed">{message}</p>
      <div className="flex justify-end mt-1">
        <span className="text-[10px] text-gray-500">
          {new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
        </span>
      </div>
    </div>
    <div className="text-center mt-2 space-y-1">
      <span className="text-xs text-content-3 block">Así se verá en WhatsApp</span>
      {footnote}
    </div>
  </div>
);

export default WhatsAppPreviewBubble;
